import './AddTeamMemberPopup.css';
import { useState, useEffect } from 'react';
import { useNotification } from 'src/hooks/useNotification';
import { useParams } from 'react-router-dom';
import AddButtonIcon from '../../assets/img/add-button-icon.svg';
import { Accordion } from '../Accorion/Accrdion';
import { AddTeamMemberForm } from './AddTeamMemberForm/AddTeamMemberForm';
import { AddTeamMemberList } from './AddTeamMemberList/AddTeamMemberList';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from 'src/components/ui/dialog';
import { clsx } from 'clsx';
import { useAddProjectTeamMembersMutation } from 'src/services';
import { Button } from 'src/components/ui/button';
import type { User } from 'src/services/usersService';
import { useLoaderWhile } from 'src/hooks/useLoaderWhile';

export const AddTeamMemberPopup = ({ disabled = false }: { disabled?: boolean }) => {
  const [open, setOpen] = useState(false);
  const notification = useNotification();
  const { id } = useParams();
  const [addTeamMember, { isLoading: isLoadingAddTeamMember, isSuccess: isSuccessAddTeamMember }] =
    useAddProjectTeamMembersMutation();

  const createTeamMember = (userResponse: User) => {
    const request = {
      users: [userResponse.id],
    };
    addTeamMember({ id, users: request?.users });
  };

  const addTeamMemberFromList = (request: { users: number[] }) => {
    addTeamMember({ id, users: request?.users });
  };

  useEffect(() => {
    if (isSuccessAddTeamMember) {
      notification.success(`Team Member was added.`);
      setOpen(false);
    }
  }, [isSuccessAddTeamMember]);

  useLoaderWhile(isLoadingAddTeamMember);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger
        disabled={disabled}
        asChild
        className={clsx(disabled && 'pointer-events-none opacity-50', 'cursor-pointer')}
      >
        <Button variant="pill-outline" size="pill" className="card-header-button">
          <span>Add user</span>
          <img src={AddButtonIcon} />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Add team member</DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="content">
            <div className="sub-title">
              <h4>Available methods:</h4>
            </div>
            <Accordion className={'add-teammember-accordion'} title={'Create a new user'}>
              <AddTeamMemberForm onSubmit={(response) => createTeamMember(response)} />
            </Accordion>
            <Accordion
              className={'add-teammember-accordion-list'}
              title={'Select user from other your projects'}
            >
              <AddTeamMemberList onSubmit={(request) => addTeamMemberFromList(request)} />
            </Accordion>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
